import React, { useState, createContext, useContext } from 'react';
type Language = 'es' | 'en';
type Translations = { [key in Language]: {
  [key: string]: string;
} };
const translations: Translations = {
  es: {
    // Hero
    'hero.badge': 'E-book para Generar Ingresos',
    'hero.title.1': '¿Quieres empezar a generar ingresos con',
    'hero.title.2': 'en solo 14 días?',
    'hero.subtitle': 'Descubre el método paso a paso para construir tu portafolio UGC, contactar marcas y cerrar tus primeros acuerdos.',
    'hero.btn': 'Descarga aquí',
    'hero.guarantee': 'Acceso inmediato • Descarga digital',
    // Problem
    'problem.title': '¿Te suena familiar?',
    'problem.subtitle': 'Sabes que el Contenido Generado por el Usuario (UGC) es el camino para trabajar con marcas, pero te encuentras con bloqueos constantes.',
    'problem.point.1': 'No saber cómo estructurar tu oferta',
    'problem.point.2': 'Dudas sobre cómo fijar precios justos',
    'problem.point.3': 'Escribir mensajes a marcas y no obtener respuesta',
    'problem.point.4': 'Miedo a parecer poco profesional sin experiencia',
    // Solution
    'solution.title.1': 'Tu guía completa en',
    'solution.title.2': '14 días',
    'solution.subtitle': 'Este e-book te guía paso a paso para convertirte en un creador o creadora UGC profesional. Deja de adivinar y sigue un método probado.',
    'solution.item.1.title': 'Crear un portafolio atractivo',
    'solution.item.1.desc': 'En tiempo récord, incluso sin trabajos previos.',
    'solution.item.2.title': 'Contactar marcas',
    'solution.item.2.desc': 'Con scripts listos para usar que sí obtienen respuesta.',
    'solution.item.3.title': 'Definir tus tarifas',
    'solution.item.3.desc': 'Sin miedo a cobrar demasiado bajo por tu trabajo.',
    'solution.item.4.title': 'Negociar derechos de uso',
    'solution.item.4.desc': 'Ads, orgánico, exclusividad... como un profesional.',
    'solution.card.title': 'El Método 14 Días',
    'solution.card.subtitle': 'De cero a tu primer cliente',
    'solution.step.1': 'Intro UGC',
    'solution.step.2': 'Tu Oferta',
    'solution.step.3': 'Portafolio',
    'solution.step.4': 'Scripts',
    'solution.step.5': 'Tarifas',
    'solution.step.6': 'Entrega',
    'solution.step.7': 'Plataformas',
    'solution.step.8': 'Checklist',
    // Preview
    'preview.title.1': 'Todo lo que necesitas,',
    'preview.title.2': 'en un solo lugar',
    'preview.subtitle': 'Un vistazo a los módulos que transformarán tu forma de crear contenido y conseguir clientes.',
    // Benefits
    'benefits.1.title': 'Plantillas probadas',
    'benefits.1.desc': 'Incluye plantillas de mensajes usados por creadores UGC que ya trabajan con marcas reconocidas.',
    'benefits.2.title': 'Basado en experiencia real',
    'benefits.2.desc': 'No es teoría, es práctica real basada en la experiencia de cientos de campañas UGC exitosas.',
    'benefits.3.title': "Opción 'Faceless'",
    'benefits.3.desc': 'Optimizado para creadores que no quieren mostrar su cara (pero también funciona para quienes sí lo hacen).',
    // Objection
    'objection.title': '¿Y si no tengo experiencia previa?',
    'objection.highlight': 'No hay problema.',
    'objection.desc.1': 'Este e-book incluye un sistema paso a paso para crear tus primeros ejemplos de contenido',
    'objection.desc.2': 'sin necesitar marcas previas',
    'objection.desc.3': '. Aprenderás a construir un portafolio sólido desde la comodidad de tu casa.',
    // Final CTA
    'cta.title.1': 'No dejes pasar más tiempo sin',
    'cta.title.2': 'arrancar',
    'cta.subtitle': 'Consigue hoy mismo el e-book y da tu primer paso para convertirte en un creador UGC profesional.',
    'cta.btn.1': 'Obtener el e-book ahora – $6.41 USD',
    'cta.btn.2': 'Descarga',
    'cta.trust.1': 'Pago Seguro',
    'cta.trust.2': 'Acceso Inmediato',
    // Footer
    'footer.rights': 'UGC E-book. Todos los derechos reservados.',
    'footer.terms': 'Términos y Condiciones',
    'footer.privacy': 'Política de Privacidad',
    // Terms Modal
    'terms.intro': 'Al adquirir este e-book, aceptas los siguientes términos y condiciones de uso.',
    'terms.1.title': '1. Licencia de uso:',
    'terms.1.desc': 'Este e-book es para uso personal e intransferible. No está permitida su distribución, copia o reventa sin autorización expresa.',
    'terms.2.title': '2. Propiedad intelectual:',
    'terms.2.desc': 'Todo el contenido del e-book, incluyendo textos, plantillas y recursos, está protegido por derechos de autor.',
    'terms.3.title': '3. Reembolsos:',
    'terms.3.desc': 'Debido a la naturaleza digital del producto, no se aceptan devoluciones una vez realizada la descarga.',
    'terms.4.title': '4. Responsabilidad:',
    'terms.4.desc': 'Los resultados pueden variar según la dedicación y esfuerzo de cada usuario. No garantizamos ingresos específicos.',
    'terms.5.title': '5. Modificaciones:',
    'terms.5.desc': 'Nos reservamos el derecho de actualizar estos términos en cualquier momento.',
    // Privacy Modal
    'privacy.intro': 'Tu privacidad es importante para nosotros. Esta política describe cómo recopilamos y usamos tu información.',
    'privacy.1.title': '1. Datos recopilados:',
    'privacy.1.desc': 'Al realizar tu compra, recopilamos tu nombre, correo electrónico y datos de pago necesarios para procesar la transacción.',
    'privacy.2.title': '2. Uso de datos:',
    'privacy.2.desc': 'Tus datos se utilizan exclusivamente para entregar el producto y enviarte actualizaciones relacionadas.',
    'privacy.3.title': '3. Protección:',
    'privacy.3.desc': 'Utilizamos medidas de seguridad estándar para proteger tu información personal.',
    'privacy.4.title': '4. Terceros:',
    'privacy.4.desc': 'No compartimos ni vendemos tu información personal a terceros sin tu consentimiento.',
    'privacy.5.title': '5. Contacto:',
    'privacy.5.desc': 'Si tienes preguntas sobre esta política, puedes contactarnos por correo electrónico.'
  },
  en: {
    // Hero
    'hero.badge': 'Income Generating E-book',
    'hero.title.1': 'Want to start generating income with',
    'hero.title.2': 'in just 14 days?',
    'hero.subtitle': 'Discover the step-by-step method to build your UGC portfolio, pitch brands, and close your first deals.',
    'hero.btn': 'Download here',
    'hero.guarantee': 'Instant access • Digital download',
    // Problem
    'problem.title': 'Sound familiar?',
    'problem.subtitle': 'You know User Generated Content (UGC) is the way to work with brands, but you constantly hit roadblocks.',
    'problem.point.1': 'Not knowing how to structure your offer',
    'problem.point.2': 'Doubts about how to set fair prices',
    'problem.point.3': 'Pitching brands and getting no response',
    'problem.point.4': 'Fear of looking unprofessional without experience',
    // Solution
    'solution.title.1': 'Your complete guide in',
    'solution.title.2': '14 days',
    'solution.subtitle': 'This e-book guides you step-by-step to become a professional UGC creator. Stop guessing and follow a proven method.',
    'solution.item.1.title': 'Create an attractive portfolio',
    'solution.item.1.desc': 'In record time, even without previous work.',
    'solution.item.2.title': 'Pitch brands',
    'solution.item.2.desc': 'With ready-to-use scripts that actually get replies.',
    'solution.item.3.title': 'Set your rates',
    'solution.item.3.desc': 'Without fear of charging too little for your work.',
    'solution.item.4.title': 'Negotiate usage rights',
    'solution.item.4.desc': 'Ads, organic, exclusivity... like a pro.',
    'solution.card.title': 'The 14-Day Method',
    'solution.card.subtitle': 'From zero to your first client',
    'solution.step.1': 'UGC Intro',
    'solution.step.2': 'Your Offer',
    'solution.step.3': 'Portfolio',
    'solution.step.4': 'Scripts',
    'solution.step.5': 'Rates',
    'solution.step.6': 'Delivery',
    'solution.step.7': 'Platforms',
    'solution.step.8': 'Checklist',
    // Preview
    'preview.title.1': 'Everything you need,',
    'preview.title.2': 'in one place',
    'preview.subtitle': 'A look at the modules that will transform how you create content and get clients.',
    // Benefits
    'benefits.1.title': 'Proven templates',
    'benefits.1.desc': 'Includes message templates used by UGC creators who already work with recognized brands.',
    'benefits.2.title': 'Based on real experience',
    'benefits.2.desc': 'Not theory, real practice based on the experience of hundreds of successful UGC campaigns.',
    'benefits.3.title': 'Faceless option',
    'benefits.3.desc': "Optimized for creators who don't want to show their face (but also works for those who do).",
    // Objection
    'objection.title': 'What if I have no prior experience?',
    'objection.highlight': 'No problem.',
    'objection.desc.1': 'This e-book includes a step-by-step system to create your first content examples',
    'objection.desc.2': 'without needing prior brands',
    'objection.desc.3': '. You will learn to build a solid portfolio from the comfort of your home.',
    // Final CTA
    'cta.title.1': "Don't let more time pass without",
    'cta.title.2': 'starting',
    'cta.subtitle': 'Get the e-book today and take your first step to becoming a professional UGC creator.',
    'cta.btn.1': 'Get the e-book now – $6.41 USD',
    'cta.btn.2': 'Download',
    'cta.trust.1': 'Secure Payment',
    'cta.trust.2': 'Instant Access',
    // Footer
    'footer.rights': 'UGC E-book. All rights reserved.',
    'footer.terms': 'Terms and Conditions',
    'footer.privacy': 'Privacy Policy',
    // Terms Modal
    'terms.intro': 'By purchasing this e-book, you agree to the following terms and conditions of use.',
    'terms.1.title': '1. License of use:',
    'terms.1.desc': 'This e-book is for personal and non-transferable use. Distribution, copying, or resale without express authorization is not permitted.',
    'terms.2.title': '2. Intellectual property:',
    'terms.2.desc': 'All content in the e-book, including texts, templates, and resources, is protected by copyright.',
    'terms.3.title': '3. Refunds:',
    'terms.3.desc': 'Due to the digital nature of the product, returns are not accepted once the download is complete.',
    'terms.4.title': '4. Liability:',
    'terms.4.desc': 'Results may vary depending on the dedication and effort of each user. We do not guarantee specific income.',
    'terms.5.title': '5. Modifications:',
    'terms.5.desc': 'We reserve the right to update these terms at any time.',
    // Privacy Modal
    'privacy.intro': 'Your privacy is important to us. This policy describes how we collect and use your information.',
    'privacy.1.title': '1. Data collected:',
    'privacy.1.desc': 'When making your purchase, we collect your name, email, and payment details necessary to process the transaction.',
    'privacy.2.title': '2. Data usage:',
    'privacy.2.desc': 'Your data is used exclusively to deliver the product and send you related updates.',
    'privacy.3.title': '3. Protection:',
    'privacy.3.desc': 'We use standard security measures to protect your personal information.',
    'privacy.4.title': '4. Third parties:',
    'privacy.4.desc': 'We do not share or sell your personal information to third parties without your consent.',
    'privacy.5.title': '5. Contact:',
    'privacy.5.desc': 'If you have questions about this policy, you can contact us by email.'
  }
};
interface LanguageContextType {
  lang: Language;
  toggleLang: () => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [lang, setLang] = useState<Language>('es');
  const toggleLang = () => {
    setLang(prev => prev === 'es' ? 'en' : 'es');
  };
  const t = (key: string): string => {
    return translations[lang][key] || key;
  };
  return <LanguageContext.Provider value={{
    lang,
    toggleLang,
    t
  }} data-id="element-156">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};